import { render, staticRenderFns } from "./userdetail.vue?vue&type=template&id=7975b561&"
import script from "./userdetail.vue?vue&type=script&lang=js&"
export * from "./userdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports